import React from 'react'
import { useNavigate } from 'react-router-dom'
import ModalCommon from 'src/components/common/ModalCommon'
import DiamondRed from 'src/assets/img/common/diamond-red.png'
import PropTypes from 'prop-types'
import putUpRank from 'src/services/put/putUpRank'
import { authActionTypes, useAuthDispatch } from 'src/providers/AuthProviders'
import getUserInfo from 'src/services/get/getUserInfo'
import { RANK_IMAGES } from 'src/pages/main/house/const/houseConstants'

const RANK_UP_PRICE = 70

function ModalPaymentRankUp({
  open,
  setOpenModalUpRank,
  userId,
  userRank,
  userRedAmount,
  onCloseModal
}) {
  const nextRank = userRank === 'bronze' ? 'silver' : 'gold'
  const authDispatch = useAuthDispatch()
  const navigate = useNavigate()

  const reloadUser = async () => {
    try {
      const updatedUser = await getUserInfo()
      authDispatch({ type: authActionTypes.LOGIN_USER, payload: updatedUser })
    } catch (error) {
      console.error(error)
    }
  }

  const handleClose = () => {
    setOpenModalUpRank(false)
  }

  const upRank = async () => {
    try {
      const response = await putUpRank(userId, userRank)
      if (response === false) return false
      return true
    } catch (error) {
      console.error(error)
    }
  }

  const handleSubmit = async () => {
    setOpenModalUpRank(false)
    if (userRedAmount >= RANK_UP_PRICE) {
      const success = await upRank()
      if (success) {
        await reloadUser()
        onCloseModal()
      }
    } else {
      navigate('/shop/buy')
    }
  }

  return (
    <ModalCommon
      open={open}
      title="確認"
      onClose={handleClose}
      buttons={[
        {
          label: 'キャンセル',
          type: 'close',
          onClick: handleClose
        },
        {
          label: 'OK',
          onClick: handleSubmit
        }
      ]}
      theme="pink"
      height="max-h-[80%]"
    >
      <div className="flex flex-col gap-6 items-center justify-center p-6 mb-2 bg-blue-100">
        <div className="text-pink-400 font-semibold">
          赤ダイヤ70個で{nextRank === 'gold' ? 'ゴールドムーン' : 'シルバームーン'}にランクアップしますか？
        </div>
        <div className="flex gap-2 px-3 py-2 bg-white">
          <div className="relative">
            <img src={DiamondRed} alt="Diamond" className="w-full h-full object-contain" />
            <span className="absolute bottom-0 right-0 font-bold">{RANK_UP_PRICE}</span>
          </div>
          <div className="flex items-center text-xl text-pink-400 mr-1">⇨ </div>
          <div className="w-[69px]">
            <img
              src={RANK_IMAGES[nextRank]}
              alt={nextRank}
              className="w-full h-full object-contain"
            />
          </div>
        </div>
        <div className="text-pink-400 font-bold">所持赤ダイヤ</div>
        <div className="flex items-center gap-2">
          <img src={DiamondRed} alt="Diamond" className="w-10" />
          <div className="font-bold">{userRedAmount}</div>
          <div className="text-xl text-pink-400">⇨ </div>
          <div className="font-bold text-red-500">{userRedAmount - 70}</div>
        </div>
      </div>
    </ModalCommon>
  )
}

ModalPaymentRankUp.propTypes = {
  open: PropTypes.bool,
  setOpenModalUpRank: PropTypes.func,
  userId: PropTypes.number,
  userRank: PropTypes.string,
  userRedAmount: PropTypes.number,
  onCloseModal: PropTypes.func
}

export default ModalPaymentRankUp
